import SidebarSection from "components/SidebarSection"

export default function SidebarSectionDynamic({ blok }) {
  return <SidebarSection content={blok.content} />
}
